import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ProductsComponent } from "./shopping/components/products/products.component";
import { ShoppingCartComponent } from "./shopping/components/shopping-cart/shopping-cart.component";
import { LandingPageComponent } from "./shopping/components/landing-page/landing-page.component";
import { ProductComponent } from "./shopping/components/product/product.component";
import { CheckoutComponent } from './shopping/components/checkout/checkout.component';
import { OrderSuccessComponent } from './shopping/components/order-success/order-success.component';
import { PaymentComponent } from './shopping/components/payment/payment.component';
import { InvalidStoreComponent } from './core/components/invalid-store/invalid-store.component';

const routes: Routes = [];

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: "",
        component: ProductsComponent
      },
      {
        path: "products",
        component: ProductsComponent
      },
      {
        path: "shop",
        component: LandingPageComponent
      },
      {
        path: "product/:productSlug",
        component: ProductComponent
      },
      {
        path: "shopping-cart",
        component: ShoppingCartComponent
      },
      {
        path: "checkout",
        component: CheckoutComponent
      },
      {
        path: "order-success",
        component: OrderSuccessComponent
      },
      {
        path: "payment",
        component: PaymentComponent
      },
      {
        path: "not-found",
        component: InvalidStoreComponent
      },
    ])
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
